import { useEffect } from "react";

const LinkedinCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (!code) {
      window.close();
      return;
    }

    // send code to main window
    window.opener.postMessage(
      {
        type: "LINKEDIN_LOGIN_CODE",
        code
      },
      window.location.origin
    );

    window.close();
  }, []);

  return <p style={{ padding: 20 }}>Signing in with LinkedIn...</p>;
};

export default LinkedinCallback;
